<script lang="ts" setup>
import { onMounted } from 'vue';
import { useTranslations } from '~/composables/translations';
import LinkOverview from '~/components/FAQ/LinkOverview.vue';
import { scrollToTop } from '~/modules/helpers';

import type { FAQMenuContent } from '~/models/faq_models';
import { useSettingsStore } from '~/stores/settings';
import useI18NAsync from '~/composables/i18nAsync';
import BackButton from '~/components/BackButton.vue';

const { $i18n } = useTranslations('faq_faq');
const i18nSuspense = useI18NAsync('faq_faq');

const settings = useSettingsStore();
const props = defineProps<{
  type: string;
  content: FAQMenuContent[];
  routerArticles: string;
}>();

onMounted(() => {
  // Fix for the redirect from Become Partner
  scrollToTop();
});
</script>
<template>
  <div class="mp-container flex flex-column grid-gap-30px full-height">
    <div
      class="flex title"
      :class="{
        'justify-space-between': settings.isAddinMode,
        'justify-center': !settings.isAddinMode,
      }"
    >
      <BackButton v-if="settings.isAddinMode" class="back" @back="$router.back()" />
      <h1>
        <i18nSuspense ikey="faqTitle" /> <span> - <i18nSuspense ikey="faqServiceName" /></span>
      </h1>
      <div v-if="settings.isAddinMode" class="spacer" />
    </div>
    <LinkOverview
      :title="$i18n('summary')"
      :content="content"
      :module="`faq_${props.type}`"
      @redirect-to-link="$router.push({ name: props.routerArticles, params: { id: $event } })"
    />
  </div>
</template>
<style lang="css" scoped>
.back {
  margin-top: 22px;
}
</style>
